// extracted by css-extract-rspack-plugin
export default {"grabber":"UMchs","parent":"Kdg2e"};